(function (factory) {
	if (typeof define === 'function' && define.amd) {
		// AMD (Register as an anonymous module)
		define(['jquery'], factory);
	} else if (typeof exports === 'object') {
		// Node/CommonJS
		module.exports = factory(require('jquery'));
	} else {
		// Browser globals
		factory(jQuery);
	}
}(function ($) {

	var pluses = /\+/g;

	function encode(s) {
		return config.raw ? s : encodeURIComponent(s);
	}

	function decode(s) {
		return config.raw ? s : decodeURIComponent(s);
	}

	function stringifyCookieValue(value) {
		return encode(config.json ? JSON.stringify(value) : String(value));
	}

	function parseCookieValue(s) {
		if (s.indexOf('"') === 0) {
			// This is a quoted cookie as according to RFC2068, unescape...
			s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
		}

		try {
			// Replace server-side written pluses with spaces.
			// If we can't decode the cookie, ignore it, it's unusable.
			// If we can't parse the cookie, ignore it, it's unusable.
			s = decodeURIComponent(s.replace(pluses, ' '));
			return config.json ? JSON.parse(s) : s;
		} catch(e) {}
	}

	function read(s, converter) {
		var value = config.raw ? s : parseCookieValue(s);
		return $.isFunction(converter) ? converter(value) : value;
	}

	var config = $.cookie = function (key, value, options) {

		// Write

		if (arguments.length > 1 && !$.isFunction(value)) {
			options = $.extend({}, config.defaults, options);

			if (typeof options.expires === 'number') {
				var days = options.expires, t = options.expires = new Date();
				t.setMilliseconds(t.getMilliseconds() + days * 864e+5);
			}

			return (document.cookie = [
				encode(key), '=', stringifyCookieValue(value),
				options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
				options.path    ? '; path=' + options.path : '',
				options.domain  ? '; domain=' + options.domain : '',
				options.secure  ? '; secure' : ''
			].join(''));
		}

		// Read

		var result = key ? undefined : {},
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all. Also prevents odd result when
			// calling $.cookie().
			cookies = document.cookie ? document.cookie.split('; ') : [],
			i = 0,
			l = cookies.length;

		for (; i < l; i++) {
			var parts = cookies[i].split('='),
				name = decode(parts.shift()),
				cookie = parts.join('=');

			if (key === name) {
				// If second argument (value) is a function it's a converter...
				result = read(cookie, value);
				break;
			}

			// Prevent storing a cookie that we couldn't decode.
			if (!key && (cookie = read(cookie)) !== undefined) {
				result[name] = cookie;
			}
		}

		return result;
	};

	config.defaults = {};

	$.removeCookie = function (key, options) {
		// Must not alter options, thus extending a fresh object...
		$.cookie(key, '', $.extend({}, options, { expires: -1 }));
		return !$.cookie(key);
	};

}));


$(function () {
    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    // Check (onLoad) if the cookie is there and set the class if it is
    if ($.cookie('kiosk') == "yes") {
        $("body").addClass("kiosk");
        $('#switch').addClass('on');
    }

    // When the span is clicked
    $("#switch").click(function () {
        // Check the current cookie value
        // If the cookie is empty or set to no, then add highcontrast
        if ($.cookie('kiosk') == "undefined" || $.cookie('kiosk') == "no") {
            // Set cookie value to yes
            $.cookie('kiosk', 'yes', {
                expires: 7,
                path: '/'
            });
            // Add the class to the body
            $("body").addClass("kiosk");
            $("#switch").addClass('on');
        }
        // If the cookie was already set to yes then remove it
        else {
            $.cookie('kiosk', 'no', {
                expires: 365,
                path: '/'
            });
            $("body").removeClass("kiosk");
            $('#switch').removeClass('on');
        }
    });

    var knav = $("#kansai-group"),
        windowHeight = $(window).height(),
        docHeight = $(document).height(),
        navHeight = $("#kansai-group-nav").height(),
        menuHeight = $("#shopify-section-header").height();

    if (knav.length > 0) {
        var aChildren = $("#kansai-group > ul > li").children(),
            aArray = [];

        for (var i = 0; i < aChildren.length; i++) {
            var aChild = aChildren[i];
            var ahref = $(aChild).attr('href');
            aArray.push(ahref);
        }
        //console.log('aArray: ' + aArray);

        //smooth scrolling to section from other pages
        var hashURLorg = window.location.hash;
        var hashURL = hashURLorg.split('?')[0];
        //console.log('hashURL ' + hashURL);

        if(hashURL != "" && hashURL.length > 2){
            $(window).scrollTop(0);
            smoothScrollTo(hashURL);
            //console.log('scrolled from other page');
        }

        function smoothScrollTo(hashURL) {
            var targetY = (isMobile) ? $(hashURL).offset().top - menuHeight + 1 : $(hashURL).offset().top - navHeight + 1;
            $("html, body").animate({
                scrollTop: targetY
            }, 1000);
            //console.log( 'scrollTop: ' + targetY );
        }

        $("#kansai-group a").click(function () {
            var divID = $(this).attr('href');
            var scrollTo = ( isMobile ) ? $(divID).offset().top - menuHeight + 1 : $(divID).offset().top - navHeight + 1;
            $("#kansai-group li").removeClass("active-link");
            $(this).parent().addClass("active-link");
            $('html, body').animate({
                scrollTop: scrollTo
            }, 1000);
            //console.log(divID);
        });

        $(window).scroll(function(){
            var windowPos = $(window).scrollTop(),
                windowBottom = windowPos + windowHeight;

            // adding "current" class to nav items when scrolled into view
            for (var i=0; i < aArray.length; i++) {
                var theID = aArray[i];
                var divPos = ( isMobile ) ? $(theID).offset().top - menuHeight : $(theID).offset().top - navHeight;
                var divHeight = $(theID).height();

                if ( (windowPos > divPos) && (windowPos < (divPos + divHeight))) {
                    $("a[href='" + theID + "']").parent().addClass("active-link");
                    //console.log( theID );
                } else {
                    $("a[href='" + theID + "']").parent().removeClass("active-link");
                }
            }

            // adding "current" class to last nav item
            if (windowPos + windowHeight  == docHeight) {
                if (!$("#kansai-group li:nth-child(" + aArray.length + ")").hasClass("active-link")) {
                    $("#kansai-group li").removeClass("active-link");
                    $("#kansai-group li:nth-child(" + aArray.length + ")").addClass("active-link");
                }
            }
        });
    }
});